import type { ReactNode } from 'react';

import type { Action } from './permissions';

import { usePermissions } from './use-permissions';

export interface CanProps {
  action: Action;
  children: ReactNode;
}

export function Can({ action, children }: CanProps) {
  const { can } = usePermissions();
  return can(action) ? children : null;
}
